// import {
//     SYSTEM_SETTING,
// } from '@/store/api/center';

const state = {
    isCurrentCenter: false, // 判断是否个人中心进来
    isOpenDirector: false, // 控制显示人员视图、任务视图列表
    isOpenTaskDetail: false, // 控制是否打开任务视图详情
    isOpenPersonnelDetail: false, // 控制是否打开人员视图详情
    personnelDetailQuery: {}, // 人员视图列表参数
    personnelSonDetail: {}, // 人员视图子详情
    studyPushVisible: false, // 控制是否打开推送包
    addStudyPushVisible: false, // 控制是否打开推送包
    studyPushDetailVisible: false, // 推送详情
    addStudyPushDetailVisible: false, // 控制是否打开推送包详情
    studyPushDetailRecordVisible: false, // 控制是否打开推送包详情的个人记录
    currOfficeComponent: 'OfficeIndex', // 办公主页当前显示的导航组件名，默认显示待办记录
    pushDetailId: '',
    storeSavePushId: '',
    pushRecordQuery: {}, // 人员视图列表参数
    pushRecordDetailId: '',
    pushRecordDetail: {},
    courseSelectIds: {}, // 存储推送包-配置内容-已选中的资源id,
    pushStudentSelectIds: [], // 存储推送包-配置内容-已选中的受众id
    pushContentSequence: 0, // 记录添加资源的当前顺序
};

const getters = {
    isOpenDetail(mState) {
        const {
            isCurrentCenter,
            isOpenTaskDetail,
            isOpenPersonnelDetail,
            studyPushVisible,
            studyPushDetailVisible,
            studyPushDetailRecordVisible
        } = mState;
        if ([
            isCurrentCenter,
            isOpenTaskDetail,
            isOpenPersonnelDetail,
            studyPushVisible,
            studyPushDetailVisible,
            studyPushDetailRecordVisible
        ].includes(true)) return true;

        return false;
    }
};

const actions = {
    // requestLayoutData({ rootState }) {
    //     return rootState.app.$http.get(SYSTEM_SETTING, { loading: true });
    // }
    defaultTaskDetail({ commit }, param = true) {
        commit('defaultTaskDetail', param);
    },
    setOpenTaskDetail({ commit }, param) {
        commit('setOpenTaskDetail', param);
    },
    setCurrentCenter({ commit }, param) {
        commit('setCurrentCenter', param);
    },
    setOpenPersonnelDetail({ commit }, param) {
        commit('setOpenPersonnelDetail', param);
    },
    setPersonnelDetailQuery({ commit }, param) {
        commit('SET_PERSONNEL_DETAIL_QUERY', param);
    },
    setOpenPersonnelDetailSource({ commit }, param) {
        commit('setOpenPersonnelDetailSource', param);
    },
    setVisibleStudyPush({ commit }, param) {
        commit('setVisibleStudyPush', param);
    },
    setVisibleAddStudyPush({ commit }, param) {
        commit('setVisibleAddStudyPush', param);
    },
    setStudyPushDetailVisible({ commit }, param) {
        commit('setStudyPushDetailVisible', param);
    },
    setVisibleAddStudyPushDetail({ commit }, param) {
        commit('setVisibleAddStudyPushDetail', param);
    },
    setVisibleStudyPushDetailRecord({ commit }, param) {
        commit('setVisibleStudyPushDetailRecord', param);
    },
    setCurrOfficeComponent({ commit }, param) {
        commit('setCurrOfficeComponent', param);
    },
    setPushDetailId({ commit }, param) {
        commit('setPushDetailId', param);
    },
    setStoreSavePushId({ commit }, param) {
        commit('setStoreSavePushId', param);
    },
    setPushRecordQuery({ commit }, param) {
        commit('setPushRecordQuery', param);
    },
    setPushRecordDetailId({ commit }, param) {
        commit('setPushlRecordDetaiId', param);
    },
    setPushRecordDetail({ commit }, param) {
        commit('setPushRecordDetail', param);
    },
    setCourseSelectIds({ commit }, param) {
        commit('setCourseSelectIds', param);
    },
    setPushStudentSelectIds({ commit }, param) {
        commit('setPushStudentSelectIds', param);
    },
    setPushContentSequence({ commit }, param) {
        commit('setPushContentSequence', param);
    },
};

const mutations = {
    init(mState) {
        mState.isOpenDirector = false;
        mState.isOpenTaskDetail = false;
        mState.isOpenPersonnelDetail = false;
        mState.studyPushVisible = false;
        window.scrollTo(0, 0);
        // todo: 所有的详情页面都要在这定义一下
    },
    defaultTaskDetail(mState, param) { // 我是主管
        this.commit('center/init');
        mState.isOpenDirector = param;
    },
    setOpenTaskDetail(mState, param) { // 任务视图详情
        this.commit('center/init');
        mState.isOpenTaskDetail = param;
    },
    setCurrentCenter(mState, param) { // 任务视图详情
        this.commit('center/init');
        mState.isCurrentCenter = param;
    },
    setOpenPersonnelDetail(mState, param) { // 人员视图详情
        this.commit('center/init');
        mState.isOpenPersonnelDetail = param;
    },
    SET_PERSONNEL_DETAIL_QUERY(mState, param) {
        mState.personnelDetailQuery = param;
    },
    setVisibleStudyPush(mState, param) { // 推送
        this.commit('center/init');
        mState.studyPushVisible = param;
    },
    setVisibleAddStudyPush(mState, param) {
        mState.addStudyPushVisible = param;
    },
    setStudyPushDetailVisible(mState, param) {
        mState.studyPushDetailVisible = param;
    },
    setVisibleAddStudyPushDetail(mState, param) {
        mState.addStudyPushDetailVisible = param;
    },
    setVisibleStudyPushDetailRecord(mState, param) {
        mState.studyPushDetailRecordVisible = param;
    },
    resetCurrOfficeComponent() {
        state.currOfficeComponent = 'OfficeIndex';
    },
    setCurrOfficeComponent(mState, param) {
        mState.currOfficeComponent = param;
    },
    setPushDetailId(mState, param) {
        mState.pushDetailId = param;
    },
    setStoreSavePushId(mState, param) {
        mState.storeSavePushId = param;
    },
    setPushRecordQuery(mState, param) {
        mState.pushRecordQuery = param;
    },
    setPushlRecordDetaiId(mState, param) {
        mState.pushRecordDetailId = param;
    },
    setCourseSelectIds(mState, param) {
        mState.courseSelectIds = param;
    },
    setPushStudentSelectIds(mState, param) {
        mState.pushStudentSelectIds = param;
    },
    setPushContentSequence(mState, param) {
        mState.pushContentSequence = param;
    },
    setPushRecordDetail(mState, param) {
        mState.pushRecordDetail = param;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

